import { BaseRequest } from './BaseRequest';

export class AgentRequest extends BaseRequest {
    Attendants: null | [];
}